module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/info/blog/blog.component.scss
// module id = ./src/app/landing/info/blog/blog.component.scss
// module chunks = main